/* ═══════════════════════════════════════════════════════════════════
   iso-wizard-cart-watcher.js
   v236.1 (2026-05-25) — LEAN VERSION

   Nur ein leichtgewichtiger Helper. KEIN Polling, KEIN Fetch-Interceptor,
   KEIN MutationObserver. Wird nur explizit aufgerufen wenn das
   Sanierungspaket via X-Button aus dem Cart entfernt wird.

   Exposed:
     window.IsoWizardReset.clearState()

   Wird aufgerufen von:
     - snippets/cart-drawer.liquid (Dawn-Standard Cart-Drawer)
     - assets/isodash-mini-cart.js (Dashboard Mini-Cart)
   ═══════════════════════════════════════════════════════════════════ */
(function (w) {
  'use strict';

  if (w.IsoWizardReset && w.IsoWizardReset.__loaded) return;

  var WIZARD_STORAGE_KEYS = [
    'isofinAnalysis',
    'isofinCalcState',
    '__ISOWIZ_RESUME_ANALYSIS__',
    '__ISOWIZ_RESUME_STEP__',
    '__ISOWIZ_RESUME_STEP4_ONCE__',
    '__ISOWIZ_RESUME_TS__',
    '__ISOWIZ_RESUME_VERSION__',
    '__ISOWIZ_RETURN_TO_STEP__',
    '__ISOWIZ_RETURN_TO_STEP4__',
    '__ISOWIZ_RETURN_TO_STEP4_TS__',
    '__ISOWIZ_RETURN_TS__',
    '__ISOWIZ_RETURN_URL__',
    '__ISOWIZ_RETURN_URL_TS__',
    '__ISOWIZ_START_INTENT__',
    '__ISOWIZ_TRACK_FLOW_ID__',
    '__ISOWIZ_CART_MISMATCH_NOTICE__',
    '__ISOWIZ_MISMATCH_DISMISSED__',
    'isowiz_step4_completedSignature'
  ];

  function clearState() {
    /* localStorage + sessionStorage Resume-Keys löschen */
    WIZARD_STORAGE_KEYS.forEach(function (key) {
      try { w.localStorage.removeItem(key); } catch (_) {}
      try { w.sessionStorage.removeItem(key); } catch (_) {}
    });

    /* Force-Empty-Step0-Flag → Wizard startet bei /pages/kalkulator auf Step 0 */
    try { w.sessionStorage.setItem('__ISOWIZ_FORCE_EMPTY_STEP0__', '1'); } catch (_) {}

    /* In-memory State zurücksetzen falls Wizard/Dashboard-Module geladen sind */
    try {
      if (w.IsoWiz && w.IsoWiz.Storage && typeof w.IsoWiz.Storage.resetAll === 'function') {
        w.IsoWiz.Storage.resetAll();
      }
    } catch (_) {}
    try {
      if (w.IsoDash && w.IsoDash.Calculations && typeof w.IsoDash.Calculations.clearAnalysis === 'function') {
        w.IsoDash.Calculations.clearAnalysis();
      }
    } catch (_) {}
    try { if (w.isofinCalculatorData) w.isofinCalculatorData = {}; } catch (_) {}
  }

  w.IsoWizardReset = { clearState: clearState, __loaded: true };
})(window);
